import instance from '../_http';

export  const getDict = (params) => {
  return instance.get('/api/common/sys-dict-data/list/signs',{params:{dictSigns:params}});
}
